import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  add
} from '../redux/alarms'

export default function * requestAddAlarm (action) {
  const { eventId, timestamp } = action.payload

  // const optimisticAction = yield optimisticPut(add(id))

  try {
    yield call(apiAction, 'AddAlarm', {
      eventId,
      timestamp
    })
  } finally {
    // yield optimisticAction.revert()
  }
}
